import answerAsExpected from 'core/controllerPlans/answerAsExpected'
import { IS_ENROLL } from 'core/constants/environment'
import toggleClass from 'utils/DOM/toggleClass'
import textContent from 'utils/DOM/textContent'
import scrollTo from 'core/DOM/scrollTo'
import getById from 'utils/DOM/getById'
import { STM_ELIGIBLE, STM_INELIGIBLE } from 'core/constants/eligibility'

const button = getById('submit')
const gapMessageNode = getById('non-eligible')

function updateDOM(state) {
  const smartlySDK = window.hc.smartlySDK // window.hc.smartlySDK is used safely because initPage() was executed before

  if (state.questions && state.answersPivot) {
    let lastEnable
    let interrupted = false
    let showNext = true

    for (const question of state.questions) {
      const id = `q${question.id}`
      const node = getById(id)
      const answer = state.answersPivot[id]

      const asExpected = answerAsExpected(answer, question.expectedAnswers)

      IS_ENROLL
        ? toggleClass(node, 'inactive', !showNext)
        : toggleClass(node, 'disable', !showNext)

      toggleClass(node, 'error', !!answer && !asExpected)
      toggleClass(gapMessageNode, 'error', !!answer && !asExpected && IS_ENROLL)
      if (answer && smartlySDK) {
        answer === 'YES'
          ? smartlySDK.track('ph_action_answer_yes_eligibility')
          : smartlySDK.track('ph_action_answer_no_eligibility')
      }

      if (showNext) {
        showNext = asExpected
        lastEnable = node
      }
      if (!asExpected && answer) {
        interrupted = true
        textContent('.js-question-warning', question.warning.slice(1).join(' '))
        textContent('.js-question-warning-title', question.warning[0])
        window.dataLayerPushEvent('ELEGIBILITY_INTERRUPT_APPLICATION')
        if (IS_ENROLL) {
          const errorDiv = getById('non-eligible')
          scrollTo(errorDiv.offsetTop)
        }
        break
      }
    }
    const hcStorage = state.hcStorage
    hcStorage.leadStatus = interrupted ? STM_INELIGIBLE : STM_ELIGIBLE

    if (lastEnable && !interrupted) {
      scrollTo(lastEnable.offsetTop)
    }

    toggleClass(button, 'disabled', !showNext)
  }
}

export default updateDOM
